import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Upload,
  Dropdown,
  Menu,
  Popconfirm,
  Checkbox,
  Card,
  Select,
  Form,
  Empty,
  Typography
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { FileService } from "../../services/file/FileService";
import { HttpService } from "../../utils/HttpService";

import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./PromptsTable.css";
import { showSuccessToast, showErrorToast } from "../general/ToastHelper";
import { convertTZToLocal } from "../general/DateTzHelper";
import * as mm from "music-metadata-browser";
import { ConsoleSqlOutlined } from "@ant-design/icons";
import AudioPlayer from "../streaming/AudioPlayer";
import TextArea from "antd/lib/input/TextArea";
import { options } from "less";
import { Constants } from "../../data/constants";
import { Translation } from "react-i18next";
import i18next from "i18next";

const { Text } = Typography;

class PromptsTable extends React.Component {
  constants = new Constants();

  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("promptsConfig");
    this.fileService = new FileService();
    this.httpService = new HttpService();
    this.state = {
      isFetching: false,
      validatePromptName: "success",
      searchText: "",
      file: null,
      uploading: false,
      data: [],
      ttsCheck: false,
      uploadCheck: true,
      speakers: [],
      promptName: "",
      languages: [
        {
          name: "English",
          nameAr: "الإنجليزية",
          code: "en-US",
        },
        {
          name: "Arabic",
          nameAr: "العربية",
          code: "arb",
        },
        {
          name: "French",
          nameAr: "الفرنسية",

          code: "fr-FR",
        },
        {
          name: "German",
          nameAr: "الألمانية",

          code: "de-DE",
        },
      ],
      speakers: [
        {
          name: "Female",
          nameAr: "انثى",
          code: "ai3-Kailey",
          langCode: "en-US",
        },
        {
          name: "Male",
          nameAr: "ذكر",
          code: "ai3-Jason",
          langCode: "en-US",
        },
        {
          name: "Female",
          nameAr: "انثى",
          code: "ai3-fr-FR-Camille",
          langCode: "fr-FR",
        },
        {
          name: "Male",
          nameAr: "ذكر",
          code: "ai3-fr-FR-Cannan",
          langCode: "fr-FR",
        },
        {
          name: "Female",
          nameAr: "انثى",

          code: "ai3-ar-XA-Salma",
          langCode: "arb",
        },
        {
          name: "Male",
          nameAr: "ذكر",

          code: "ai3-ar-XA-Shakir",
          langCode: "arb",
        },
        {
          name: "Female",
          nameAr: "انثى",
          code: "ai3-de-DE-Galliena",
          langCode: "de-DE",
        },
        {
          name: "Male",
          nameAr: "ذكر",
          code: "ai3-de-DE-Ermanno",
          langCode: "de-DE",
        },
      ],
      selectedLanguage: "en-US",
      defaultOptions: [],
      selectedSpeaker: "",
      selectedSpeakers: [],
      textToConvert: "",
      promptNames: [],
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search`) + i18next.t(`${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidMount() {
    this.getAllPrompts();
    // let speakers = [
    //   "fr-Marlène",
    //   "fr-Cole",
    //   "arb-Salma",
    //   "arb-Shokier",
    //   "en-Joey",
    //   "en-Jessi",
    //   "de-Hans",
    //   "de-Lena",
    // ];
    let speakers = this.state.speakers.filter((element) => {
      return element.langCode == this.state.selectedLanguage;
    });
    let defaultOptions = [];

    this.setState({
      selectedSpeakers: speakers,
      defaultOptions: defaultOptions,
      selectedSpeaker: speakers[0].code,
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getAllPrompts() {
    try {
      this.setState({ isFetching: true });
      let data = await this.fileService.getPromptsService(
        this.props.context.session_id
      );
      if (data.ivrList.length) {
        let promptNames = [];
        data.ivrList.forEach((element) => {
          promptNames.push(element.name);
        });
        this.setState({ promptNames: promptNames });
      }

      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["name"] = data.ivrList[i]["name"];
      row["createdOn"] = convertTZToLocal(data.ivrList[i]["createdOn"]);
      row["fileId"] = data.ivrList[i]["fileId"];

      updated_data.push(row);
    }
    return updated_data;
  }
  hanndleCancel = () => {
    this.setState({
      file: null,
      uploading: false,
    });
  };

  async typeAndSizeCheck(file) {
    try {
      const validTypeSize = { type: false, size: false };
      const metadata = await mm.parseBlob(this.state.file);
      if (
        metadata.format.container === "WAVE" &&
        metadata.format.bitsPerSample === 16
      ) {
        if (this.state.file.size > this.constants.MAX_WAV_SIZE) {
          validTypeSize.type = true;
          validTypeSize.size = false;
          return validTypeSize;
        }
        validTypeSize.size = true;
        validTypeSize.type = true;
        return validTypeSize;
      } else if (metadata.format.container === "MPEG") {
        if (this.state.file.size > this.constants.MAX_MPEG_SIZE) {
          validTypeSize.type = true;
          validTypeSize.size = false;
          return validTypeSize;
        }
        validTypeSize.type = true;
        validTypeSize.size = true;
        return validTypeSize;
      } else {
        validTypeSize.type = false;
        validTypeSize.size = true;
        return validTypeSize;
      }
    } catch (error) {
      // console.log(error)
      //handleError(error);
      return null
    }
  }

  handleUpload = async () => {
    this.setState({
      uploading: true,
    });

    let session_id = this.props.context.session_id;
    try {
      let fileNameWithoutExtension = this.state.file.name.replace(".", "");

      if (this.state.file.name.length > 50) {
        showErrorToast(
          i18next.t("Please select a file with a name less than 50 Characters")
        );
        this.setState({ uploading: false });
        return;
      }
      let validFile = await this.typeAndSizeCheck(this.state.file);
  
      if(validFile==null){
        showErrorToast(
          i18next.t("Invalid type, please upload MP3 or WAV file")
        );
        this.setState({
          uploading: false,
        });
        return;
      }
      if (validFile.type && validFile.size) {
        let response = await this.fileService.uploadPropmt(
          session_id,
          this.state.file
        );
        this.setState({
          file: null,
          uploading: false,
        });
        showSuccessToast(i18next.t("uploaded successfully"));
        this.getAllPrompts();
      } else {
        if (!validFile.type) {
          showErrorToast(
            i18next.t("Invalid type, please upload MP3 or WAV file")
          );
        }
        if (!validFile.size) {
          showErrorToast(
            i18next.t("The file exceed the maximum size (WAV 10MB, MP3 4MB)")
          );
        }
        this.setState({
          uploading: false,
        });
        return;
      }
    } catch (e) {
      this.setState({
        uploading: false,
      });
      handleError(e);
    }
  };
  async handleDownload(record) {
    let session_id = this.props.context.session_id;
    try {
      let response = await this.fileService.downloadPrompt(session_id, record);
    } catch (e) {
      handleError(e);
    }
  }

  handleTtsCheckBox(e) {
    let { ttsCheck } = this.state;
    ttsCheck = e.target.checked === true ? true : false;
    this.setState({ ttsCheck, uploadCheck: !ttsCheck, file: null });
  }

  handleUploadCheckBox(e) {
    let { uploadCheck } = this.state;
    uploadCheck = e.target.checked === true ? true : false;
    this.setState({ uploadCheck, ttsCheck: !uploadCheck });
  }

  handleLangDropdownChange(value) {
    let CurrentSpeakers = [];
    switch (value) {
      case "fr-FR":
        this.state.speakers
          .filter((code) => {
            return code.split("-")[0] === "fr";
          })
          .forEach((value) => {
            CurrentSpeakers.push(value);
          });

        break;
      case "en-US":
        this.state.speakers
          .filter((code) => {
            return code.split("-")[0] === "en";
          })
          .forEach((value) => {
            CurrentSpeakers.push(value);
          });
        break;
      case "de-DE":
        this.state.speakers
          .filter((code) => {
            return code.split("-")[0] === "de";
          })
          .forEach((value) => {
            CurrentSpeakers.push(value);
          });
        break;
      case "arb":
        this.state.speakers
          .filter((code) => {
            return code.split("-")[0] === "arb";
          })
          .forEach((value) => {
            CurrentSpeakers.push(value);
          });
        break;
      default:
        break;
    }
    this.setState({
      selectedSpeakers: CurrentSpeakers,
      selectedLanguage: value,
      selectedSpeaker: CurrentSpeakers[0],
    });
  }
  getTextAreaInput(e) {
    this.setState({ textToConvert: e.target.value });
  }
  handleSpeakerDropdownChange(value) {
    this.setState({ selectedSpeaker: value });
  }
  handleTxtToSpeech() {
    const { selectedLanguage, selectedSpeaker, textToConvert } = this.state;
  }

  async deleteRecord(record) {
    try {
      let data = await this.fileService.deletePrompt(
        this.props.context.session_id,
        record
      );
      showSuccessToast(i18next.t("Prompt deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  handleRefresh() {
    this.getAllPrompts();
  }

  uploadVoiceMakerFile = async (file) => {
    try {
      let response = await this.fileService.uploadPropmt(
        this.props.context.session_id,
        file
      );
      this.setState({
        file: null,
        uploading: false,
      });
      showSuccessToast(i18next.t("uploaded successfully"));
      this.getAllPrompts();
    } catch (e) {
      this.setState({
        uploading: false,
      });
      handleError(e);
    }
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };
  isArabic = (text) => {
    // Regular expression to match Arabic characters
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F]/;

    return arabicRegex.test(text);
  };
  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure delete this Prompt?")}
            onConfirm={() => this.deleteRecord(record)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Delete")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
        <Menu.Item onClick={() => this.handleDownload(record)}>
          <span>{i18next.t("Download")}</span>
          <Icon className={"view-details-style"} type="download" />
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }

  render() {
    const Option = Select.Option;

    const columns = [
      {
        title: i18next.t("Name"),
        dataIndex: "name",
        key: "name",
        width: "30%",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: i18next.t("Date"),
        dataIndex: "createdOn",
        key: "createdOn",
        width: "30%",
      },
      // {
      //   title: "Path",
      //   dataIndex: "filePath",
      //   key: "filePath",
      //   width: "40%",
      //   ...this.getColumnSearchProps("filePath")
      // },
      {
        title: i18next.t("Action"),
        dataIndex: "operation",

        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
      {
        title: i18next.t("Play"),
        dataIndex: "AudioPlayer",
        render: (text, record) =>
          this.state.data.length >= 1 ? (
            <AudioPlayer record={record} type="prompt" />
          ) : null,
      },
    ];

    let { isFetching } = this.state;
    const { uploading, file, defaultOptions } = this.state;

    const props = {
      showUploadList: false,

      beforeUpload: (file) => {
        this.setState((state) => ({
          file: file,
        }));
        return false;
      },
      file,
    };
    const currentDefaultOptions = [];
    const currentSelectedSpeakers = [];
    // for (let i = 0; i < defaultOptions.length; i++) {
    //   currentDefaultOptions.push(
    //     <Option key={i} value={defaultOptions[i]}>
    //       {defaultOptions[i]}
    //     </Option>
    //   );
    // }
    // for (let i = 0; i < selectedSpeakers.length; i++) {
    //   currentSelectedSpeakers.push(
    //     <Option key={i} value={selectedSpeakers[i]}>
    //       {selectedSpeakers[i]}
    //     </Option>
    //   );
    // }
    return (
      <Translation>
        {(t) => (
          <Page title={t("Prompts")}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Row style={{ marginTop: "25px" }}></Row>

                <Checkbox
                  checked={!this.state.ttsCheck}
                  onChange={(e) => {
                    this.handleUploadCheckBox(e);
                  }}
                >
                  {" "}
                  {t("Upload Prompt")}{" "}
                </Checkbox>

                {this.state.uploadCheck ? (
                  <Upload {...props}>
                    <Button
                      style={
                        this.props.context.curr_dir === "ltr" &&
                        this.props.context.curr_lang === "en"
                          ? { marginRight: "20px", marginBottom: "10px" }
                          : { marginLeft: "20px", marginBottom: "10px" }
                      }
                    >
                      <Icon
                        type="upload"
                        style={
                          this.props.context.curr_dir === "ltr" &&
                          this.props.context.curr_lang === "en"
                            ? { marginRight: "20px", marginBottom: "10px" }
                            : {
                                marginTop: " 2px",
                                marginRight: "5px",
                                float: "left",
                              }
                        }
                      />
                      {this.state.file === null
                        ? t("Select File")
                        : this.state.file.name}
                    </Button>
                  </Upload>
                ) : (
                  <></>
                )}
                {this.state.file === null ? null : (
                  <Fragment>
                    <Button
                      icon="delete"
                      className="button-delete"
                      onClick={this.hanndleCancel}
                      style={
                        this.props.context.curr_dir === "ltr" &&
                        this.props.context.curr_lang === "en"
                          ? { marginRight: "20px", marginBottom: "25px" }
                          : { marginLeft: "20px", marginBottom: "25px" }
                      }
                    ></Button>
                    <Button
                      type="primary"
                      onClick={this.handleUpload}
                      loading={uploading}
                    >
                      {uploading ? t("Uploading") : t("Start Upload")}
                    </Button>
                  </Fragment>
                )}

                <Checkbox
                  checked={!this.state.uploadCheck}
                  style={{
                    marginLeft: this.props.context.curr_dir === "rtl" ? 0 : 20,
                    marginRight: this.props.context.curr_dir === "rtl" ? 20 : 0,
                  }}
                  onChange={(e) => {
                    this.handleTtsCheckBox(e);
                  }}
                >
                  {t("Text To Speech")}
                </Checkbox>
               <Row style={{ marginBottom: "10px" }} >
                      <Text style={{margin:5,color:"#d73a31",fontSize:16}}>
    {t("Please add a prompt to inform your customers that the call may be recorded.")}
    </Text>
    </Row>
                {this.state.ttsCheck ? (
                  <>
                    {this.hanndleCancel}
                    <Card
                      size="small"
                      style={{ marginBottom: 20, marginTop: 20, border: 4 }}
                    >
                      <Form
                        layout="inline"
                        style={{
                          textAlign:
                            this.props.context.curr_dir === "rtl"
                              ? "Right"
                              : "Left",
                        }}
                      >
                        <Form.Item label={t("Select Language ")}>
                          <Select
                            style={{ width: 150, marginRight: 20 }}
                            placeholder={t("Select Language")}
                            value={this.state.selectedLanguage}
                            onChange={(value) => {
                              this.setState({ selectedLanguage: value });
                              let speakers = this.state.speakers.filter(
                                (element) => {
                                  return element.langCode == value;
                                }
                              );
                              this.setState({ selectedSpeakers: speakers });
                              this.setState({
                                selectedSpeaker: speakers[0].code,
                              });
                            }}
                          >
                            {this.state.languages.map((lang) => {
                              return (
                                <Option value={lang.code}>
                                  {" "}
                                  {this.props.context.curr_dir === "rtl"
                                    ? lang.nameAr
                                    : lang.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item label={t("Select Speaker ")}>
                          <Select
                            placeholder={t("Select Speaker")}
                            style={{ width: 150 }}
                            value={this.state.selectedSpeaker}
                            onChange={(value) =>
                              // this.handleSpeakerDropdownChange(value)
                              this.setState({ selectedSpeaker: value })
                            }
                          >
                            {this.state.selectedSpeakers.map((speaker) => {
                              return (
                                <Option value={speaker.code}>
                                  {this.props.context.curr_dir === "rtl"
                                    ? speaker.nameAr
                                    : speaker.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          label={t("Prompt Name")}
                          help={
                            this.state.validatePromptName == "error"
                              ? t("the prompt name is not valid")
                              : null
                          }
                        >
                          <Input
                            placeholder={t("Enter Prompt Name")}
                            maxLength={45}
                            onChange={(value) => {
                              this.setState({ promptName: value.target.value });
                            }}
                          ></Input>
                        </Form.Item>
                      </Form>
                      <Form.Item>
                        <TextArea
                          style={{
                            marginTop: 20,
                            marginBottom: 10,
                            border: "none",
                            // direction:
                            //   this.state.selectedLanguage == "arb"
                            //     ? "rtl"
                            //     : "ltr",
                          }}
                          rows={4}
                          maxLength={250}
                          onChange={(value) => this.getTextAreaInput(value)}
                          placeholder={t("Please Enter Your Text")}
                        ></TextArea>
                      </Form.Item>
                      <Form.Item>
                        <Button
                          className="button-submit"
                          type="primary"
                          disabled={
                            this.state.textToConvert.length == 0 ||
                            this.state.textToConvert.trim().length == 0 ||
                            this.state.validatePromptName == "error" ||
                            this.state.promptName.length == 0
                          }
                          onClick={async () => {
                            if (this.state.promptName == "") {
                              showErrorToast(i18next.t("Prompt name is empty"));
                              return;
                            }
                            this.setState({ uploading: true });
                            let fileName = this.state.promptName + ".wav";
                            if (this.state.promptNames.includes(fileName)) {
                              this.setState({ uploading: false });
                              showErrorToast(
                                i18next.t("The file name already exist")
                              );
                              return;
                            }
                            let request = {
                              Engine: "neural",
                              VoiceId: this.state.selectedSpeaker,
                              LanguageCode: this.state.selectedLanguage,
                              Text: this.state.textToConvert,
                              OutputFormat: "mp3",
                              SampleRate: "48000",
                              Effect: "default",
                              MasterSpeed: "0",
                              MasterVolume: "0",
                              MasterPitch: "0",
                            };

                            if (
                              this.isArabic(this.state.textToConvert) &&
                              this.state.selectedLanguage != "arb"
                            ) {
                              this.setState({ uploading: false });
                              showErrorToast(
                                i18next.t(
                                  "Error converting your text, please check tags or settings in text"
                                )
                              );
                              return;
                            }

                            let blob = await this.httpService.callVoiceMakerAPI(
                              request
                            );
                            if (blob != null) {
                              let file = new File(
                                [blob],
                                this.state.promptName,
                                {
                                  type: "audio/mpeg",
                                }
                              );

                              await this.uploadVoiceMakerFile(file);
                            }
                            this.setState({ uploading: false });
                            this.setState({
                              textToConvert: "",
                              promptName: "",
                            });
                          }}
                          size={"small"}
                          loading={this.state.uploading}
                        >
                          {t("Save")}
                        </Button>
                      </Form.Item>
                
                    </Card>
                
                  </>
                ) : (
                  <></>
                )}
             
                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                  bordered
                />
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}

export default withSharedStateConsumer(PromptsTable);
